// Grade points mapping for USP GPA Calculator
export const GRADES = [
  { letter: 'A+', points: 4.5 },
  { letter: 'A', points: 4.0 },
  { letter: 'B+', points: 3.5 },
  { letter: 'B', points: 3.0 },
  { letter: 'C+', points: 2.5 },
  { letter: 'C', points: 2.0 },
  { letter: 'R', points: 1.5 },
  { letter: 'D', points: 1.0 },
  { letter: 'E', points: 0 }
];

// Normalize grade inputs: accept aliases 'DX' -> 'D' and 'EX' -> 'E'
export function normalizeGrade(input) {
  if (!input || typeof input !== 'string') return null;
  const g = input.trim().toUpperCase();
  if (g === 'DX') return 'D';
  if (g === 'EX') return 'E';
  return g;
}

// Return numeric points for a given grade string, or null if unknown
export function getPoints(input) {
  const grade = normalizeGrade(input);
  if (!grade) return null;
  const found = GRADES.find(g => g.letter === grade);
  return found ? found.points : null;
}

// Compute a GPA from a { letter: count } map, or null if no grades counted
export function computeGpa(counts) {
  let totalPoints = 0;
  let totalCourses = 0;
  GRADES.forEach(grade => {
    const qty = parseInt(counts[grade.letter], 10) || 0;
    if (qty > 0) {
      totalPoints += grade.points * qty;
      totalCourses += qty;
    }
  });
  if (totalCourses === 0) return null;
  return parseFloat((totalPoints / totalCourses).toFixed(2));
}

// Grades/entries that should be excluded from GPA calculations
export const EXCLUDED_GRADE_LABELS = [
  'IP',
  'AEGROTAT',
  'AEGROTAT PASS',
  'COMPASSIONATE PASS',
  'CREDIT TRANSFER',
  'SE',
  'FAIL',
  'NC',
  'NV',
  'PAS',
  'S',
  'U',
  'EL001'
];

export function isExcludedLabel(input) {
  if (!input || typeof input !== 'string') return false;
  const t = input.trim().toUpperCase();
  return EXCLUDED_GRADE_LABELS.includes(t);
}

